import React, { Component } from "react";
import {
    Text,
    View,
    StyleSheet,
    I18nManager,
    StyleProp,
    ViewStyle,
    TouchableHighlight
} from "react-native";
import { faCheck, faLock, faLockOpen } from "../../assets/consts/faCharCodes";
import { SimpleIcon } from "../components_v2/Buttons";
import ArTheme from '../argon-ui/Theme'
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";

const ICON_SIZE = 36;

export type propsType = {
    onLockPress: () => void;
    onUnLockPress?: () => void;
    isLockCapable: boolean;
    style?: StyleProp<ViewStyle>
}

export type state = {
    isLocking: boolean;
    isUnLocking: boolean;
}

class DoorLock extends Component<propsType, state> {
    constructor(props: propsType) {
        super(props);
        this.state = {
            isLocking: false,
            isUnLocking: false
        }
    }

    handleOnLock = () => {
        typeof this.props.onLockPress === "function" && !this.state.isLocking && this.props.onLockPress();
        this.setState({ isLocking: true }, () => {
            setTimeout(() => {
                this.setState({ isLocking: false })
            }, 2000);
        })
    }
    handleOnUnLock = () => {
        typeof this.props.onUnLockPress === "function" && !this.state.isUnLocking && this.props.onUnLockPress();
        
        // this.setState({ isUnLocking: true }, () => {
        //     setTimeout(() => {
        //         this.setState({ isUnLocking: false })
        //     }, 2000);
        // })
    }

    renderIcon = (icon: string, isPressed: boolean, callback: () => void) => {
        return (<TouchableHighlight
            style={styles.icon}
            underlayColor={ArTheme.COLORS.SUCCESS}
            onPress={callback}>
            <SimpleIcon icon={isPressed ? faCheck : icon} size={20} color={isPressed ? ArTheme.COLORS.SUCCESS : ArTheme.COLORS.DEVICE_TYPES.DOORLOCK} />
        </TouchableHighlight>)
    }

    render() {
        var _style = this.props.style || {};
        let { isLockCapable } = this.props;
        let { isLocking, isUnLocking } = this.state;
        return (
            <View style={[
                styles.container,
                isLockCapable ? styles.containerBordered : {},
                { width: ICON_SIZE * (isLockCapable ? 2 : 1) + 30, justifyContent: isLockCapable ? "space-between" : "center" },
                _style]}>
                {this.renderIcon(faLockOpen, isUnLocking, this.handleOnUnLock)}
                {isLockCapable && this.renderIcon(faLock, isLocking, this.handleOnLock)}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        padding: 5,
        marginHorizontal: 15,
        borderRadius: ICON_SIZE / 2 + 5,
        backgroundColor: ArTheme.COLORS.WHITE
    },
    containerBordered: { borderColor: ArTheme.COLORS.BORDER_COLOR, borderWidth: 1 },
    icon: {
        width: ICON_SIZE,
        height: ICON_SIZE,
        borderRadius: ICON_SIZE / 2,
        justifyContent: "center",
        alignItems: "center",
        shadowColor: ArTheme.COLORS.DEVICE_TYPES.DOORLOCK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 1,
        // marginHorizontal: 5
    }
})

export default DoorLock